import React from "react";
import {
  ActionButton,
  Body5MediumTypography,
  Body6RegularTypography,
  Box,
  FlexColumn,
  FlexRow,
  Heading4SemiboldTypography,
  StyledImage,
} from "../../../index";
import { RecommendationCardProps } from "./RecommendationCard.types";
import { useFormatAmount } from "../../../hooks/useFormatAmount";

export const RecommendationCard: React.FC<RecommendationCardProps> = ({
  growth,
  index = 0,
  onCardClick,
  onCtaClick,
  className,
  dataCy,
  ctaText = "Grow",
  isLoading = false,
  cardWidth = 290,
  height = "auto",
}) => {
  const formattedPotentialEarning = useFormatAmount(
    growth?.potential_earning,
    true,
    false
  );
  const formattedTotalEarning = useFormatAmount(
    growth?.total_earnings,
    true,
    false
  );

  const handleCardClick = () => {
    if (onCardClick) {
      onCardClick();
    }
  };

  const handleCtaClick = (e?: React.MouseEvent) => {
    if (e) {
      e.stopPropagation();
    }
    if (onCtaClick) {
      onCtaClick();
    }
  };

  return (
    <Box
      key={growth.id}
      data-idx={index}
      className={className || `overlay-unrealised-product-${index}`}
      id={dataCy || `growth-bestselling-product-card-${index}`}
      width={cardWidth}
    >
      <FlexRow
        height={height}
        width={cardWidth}
        gap={8}
        p={6}
        borderRadius={8}
        border="1px solid"
        borderColor="border.default.default"
        backgroundColor="background.default.default"
        onClick={handleCardClick}
        alignItems="flex-start"
      >
        <StyledImage
          aspectRatio="70/93"
          src={growth?.product?.thumbnail_url || ""}
          alt={growth?.product?.name || "product"}
          borderRadius="4px"
          objectFit="cover"
          border="0.8px solid #D7D7D7"
          width="70px"
        />
        <FlexColumn flex={1} gap={10}>
          <FlexRow alignItems="flex-start" justifyContent="space-between">
            <FlexColumn flex={1}>
              <Body6RegularTypography
                fontFamily="Lexend"
                color="text.default.default"
              >
                Earn More Upto
              </Body6RegularTypography>
              <Heading4SemiboldTypography
                fontFamily="Lexend"
                color="text.default.default"
              >
                {isLoading
                  ? "Loading..."
                  : `₹ ${formattedPotentialEarning.fullFormattedAmount}`}
              </Heading4SemiboldTypography>
            </FlexColumn>
            <ActionButton
              variant="primary"
              id={`growth-bestselling-product-copy-cta-${index}`}
              onClick={handleCtaClick}
            >
              {ctaText}
            </ActionButton>
          </FlexRow>
          <Box
            height={0.8}
            width="100%"
            backgroundColor="border.default.default"
          />
          <FlexRow justifyContent="space-between" alignItems="center">
            <FlexColumn flex={1} justifyContent="space-between">
              <Body6RegularTypography
                fontFamily="Lexend"
                color="text.default.secondary"
              >
                Total Earning
              </Body6RegularTypography>
              <Body5MediumTypography
                fontFamily="Lexend"
                color="text.neutral.default"
              >
                {isLoading
                  ? "Loading..."
                  : `₹ ${formattedTotalEarning.fullFormattedAmount}`}
              </Body5MediumTypography>
            </FlexColumn>
            <FlexColumn
              flex={1}
              justifyContent="space-between"
              alignItems="flex-end"
            >
              <Body6RegularTypography
                fontFamily="Lexend"
                color="text.default.secondary"
              >
                Potential Earning
              </Body6RegularTypography>
              <Body5MediumTypography
                fontFamily="Lexend"
                color="text.neutral.default"
                textAlign="right"
              >
                {isLoading
                  ? "Loading..."
                  : `₹ ${formattedPotentialEarning.fullFormattedAmount}`}
              </Body5MediumTypography>
            </FlexColumn>
          </FlexRow>
        </FlexColumn>
      </FlexRow>
    </Box>
  );
};
